{
  "actual_edges": [
    {
      "from": "w1",
      "id": "w1-to-w2",
      "kind": "actual",
      "to": "w2"
    },
    {
      "from": "w2",
      "id": "w2-to-w3",
      "kind": "actual",
      "to": "w3"
    },
    {
      "from": "w3",
      "id": "w3-to-w4",
      "kind": "actual",
      "to": "w4"
    },
    {
      "from": "w4",
      "id": "w4-to-w5",
      "kind": "actual",
      "to": "w5"
    },
    {
      "from": "w5",
      "id": "w5-to-w6",
      "kind": "actual",
      "to": "w6"
    },
    {
      "from": "w6",
      "id": "w6-to-w7",
      "kind": "actual",
      "to": "w7"
    },
    {
      "from": "w7",
      "id": "w7-to-w8",
      "kind": "actual",
      "to": "w8"
    },
    {
      "from": "w8",
      "id": "w8-to-w9",
      "kind": "actual",
      "to": "w9"
    },
    {
      "from": "w9",
      "id": "w9-to-w10",
      "kind": "actual",
      "to": "w10"
    },
    {
      "from": "w10",
      "id": "w10-to-w11",
      "kind": "actual",
      "to": "w11"
    },
    {
      "from": "w11",
      "id": "w11-to-w12",
      "kind": "actual",
      "to": "w12"
    },
    {
      "from": "w12",
      "id": "w12-to-w13",
      "kind": "actual",
      "to": "w13"
    },
    {
      "from": "w13",
      "id": "w13-to-w14",
      "kind": "actual",
      "to": "w14"
    },
    {
      "from": "w14",
      "id": "w14-to-w15",
      "kind": "actual",
      "to": "w15"
    },
    {
      "from": "w15",
      "id": "w15-to-w16",
      "kind": "actual",
      "to": "w16"
    },
    {
      "from": "w16",
      "id": "w16-to-w17",
      "kind": "actual",
      "to": "w17"
    },
    {
      "from": "w17",
      "id": "w17-to-w18",
      "kind": "actual",
      "to": "w18"
    },
    {
      "from": "w18",
      "id": "w18-to-w19",
      "kind": "actual",
      "to": "w19"
    }
  ],
  "agent_commit": "c96f2ed3595162a174e680b563337f6215f6eace",
  "branch_semantics": {
    "available_actions": "legal-actions-not-future-state-branches",
    "event_choices": "legal-options-not-executed-unless-selected",
    "projected_counterfactual_states": false
  },
  "campaign_id": "playthrough-evidence-full-v1",
  "cell_id": "slacker-seed-42-40927837a583",
  "completed_weeks": 19,
  "difficulty": "normal",
  "final_ending": "cashflow_collapse",
  "game_commit": "348b9fd5501e71ebc7142e10f9068fc1490b5124",
  "game_tree": "225cd5451d09bb92da674234a79ecaf8db4beb3a",
  "nodes": [
    {
      "anomalies": [],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_school_germany",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "student_club",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": 12,
        "energy": -36,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 19,
        "money": -303,
        "social": 5,
        "stress": 11
      },
      "event": {
        "id": "arrival",
        "legal_choices": [
          {
            "choice_id": "arrival.choice_01_先去宿舍放行李",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived",
            "success_effects": {
              "energy": 10.0,
              "stress": -4.0
            },
            "success_rate": 1.0,
            "text": "先去宿舍放行李"
          },
          {
            "choice_id": "arrival.choice_02_立刻去超市和_dm_补生活用品",
            "failure_effects": {
              "energy": -6.0,
              "hunger": 6.0,
              "money": -55.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived_supplied",
            "success_effects": {
              "energy": -6.0,
              "hunger": -10.0,
              "money": -55.0,
              "stress": -3.0
            },
            "success_rate": 1.0,
            "text": "立刻去超市和 dm 补生活用品"
          },
          {
            "choice_id": "arrival.choice_03_先激活_sim_卡和银行_app",
            "failure_effects": {
              "stress": 8.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003
            },
            "set_flag": "arrived",
            "success_effects": {
              "language": 1.0,
              "stress": 4.0,
              "visa_progress": 4.0
            },
            "success_rate": 0.746,
            "text": "先激活 SIM 卡和银行 App"
          },
          {
            "choice_id": "arrival.choice_04_坐在车站缓一缓",
            "failure_effects": {
              "money": -25.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived",
            "success_effects": {
              "loneliness": 4.0,
              "money": -25.0,
              "stress": -8.0,
              "visa_progress": -2.0
            },
            "success_rate": 1.0,
            "text": "坐在车站缓一缓"
          }
        ],
        "selected_choice_id": "arrival.choice_01_先去宿舍放行李"
      },
      "evidence": {
        "decision_request_fingerprint": "16d3b300a24d596345c37d8d5b8d82d4594906efc150e98b8b5358f549cc14f4",
        "event_request_fingerprint": "797cc028adf01898e15abef098e40cba4ab4730871d1758014c9ef91597ccc1b",
        "source_line": 1,
        "source_record_sha256": "d0aa86e44a217c2afde0ee7e1eed98019047931fbcc4f44549dad2d515b73b49"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 12,
        "blocked_account_balance": -992,
        "energy": -36,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 19,
        "money": -303,
        "social": 5,
        "stress": 11,
        "unpaid_social_streak": 2,
        "week": 1
      },
      "id": "w1",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 2,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 4 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 84,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前 TestDaF 2/2/2/2。没过 4x4 会卡注册并增加语言班成本。",
            "id": "testdaf",
            "score": 70,
            "suggested_actions": [
              "language_school_germany",
              "testdaf_exam_germany"
            ],
            "title": "TestDaF 4x4"
          },
          {
            "body": "当前可支配现金 197 EUR，逾期 0 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 58,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "language_school_germany"
      ],
      "state_after": {
        "academic_progress": 22,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 64,
        "exam_readiness": 28,
        "failed_courses": 0,
        "flags": {
          "arrived": true,
          "housing_contract_active": true
        },
        "gpa_score": 61,
        "hunger": 37,
        "language": 39,
        "loneliness": 30,
        "money": 197,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 20,
        "stress": 31,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 2,
        "visa_progress": 15,
        "week": 2,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 10,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 11904,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 100,
        "exam_readiness": 11,
        "failed_courses": 0,
        "flags": {},
        "gpa_score": 61,
        "hunger": 25,
        "language": 20,
        "loneliness": 30,
        "money": 500,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 15,
        "stress": 20,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 0,
        "visa_progress": 15,
        "week": 1,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 1
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 2,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "sleep_recover",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": 14,
        "energy": -32,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 16,
        "loneliness": 2,
        "money": -197,
        "social": 3,
        "stress": 17,
        "visa_progress": 2
      },
      "event": {
        "id": "germany_language_track_start",
        "legal_choices": [
          {
            "choice_id": "germany_language_track_start.choice_01_报名密集语言班",
            "failure_effects": {
              "language": -1.0,
              "money": -420.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "language": 10.0,
              "money": -420.0,
              "stress": 6.0
            },
            "success_rate": 1.0,
            "text": "报名密集语言班"
          },
          {
            "choice_id": "germany_language_track_start.choice_02_先自学一周省钱",
            "failure_effects": {
              "language": -1.0,
              "money": -35.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -4.0,
              "language": 4.0,
              "money": 40.0,
              "stress": 5.0
            },
            "success_rate": 1.0,
            "text": "先自学一周省钱"
          },
          {
            "choice_id": "germany_language_track_start.choice_03_问学校能否条件注册",
            "failure_effects": {
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "stress": 4.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.509,
            "text": "问学校能否条件注册"
          },
          {
            "choice_id": "germany_language_track_start.choice_04_找便宜语言学校",
            "failure_effects": {
              "language": 2.0,
              "money": -220.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "language": 6.0,
              "money": -260.0,
              "stress": 8.0
            },
            "success_rate": 0.609,
            "text": "找便宜语言学校"
          }
        ],
        "selected_choice_id": "germany_language_track_start.choice_04_找便宜语言学校"
      },
      "evidence": {
        "decision_request_fingerprint": "812108a9ae30f6002f10982cbd3195ff29b47f1f9fc03c56137b23681a09daef",
        "event_request_fingerprint": "4271440ffebaa82cbacd53d5b49932ae15cf878bddaf73027dcdb9896ff5fc28",
        "source_line": 2,
        "source_record_sha256": "2c21b07451a697f5ac392bfa68aac8c2c98d3bf7c6400da2ac86be07db5953e3"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 14,
        "arrears_amount": 318,
        "cash_shortfall_count": 2,
        "energy": -32,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 16,
        "loneliness": 2,
        "money": -197,
        "social": 3,
        "stress": 17,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w2",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 3,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 3 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 91,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 318 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 78,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "当前 TestDaF 2/2/2/2。没过 4x4 会卡注册并增加语言班成本。",
            "id": "testdaf",
            "score": 70,
            "suggested_actions": [
              "language_school_germany",
              "testdaf_exam_germany"
            ],
            "title": "TestDaF 4x4"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 36,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 318,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 2,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 45,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 49,
        "language": 55,
        "loneliness": 32,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 23,
        "stress": 48,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 4,
        "visa_progress": 17,
        "week": 3,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 22,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 64,
        "exam_readiness": 28,
        "failed_courses": 0,
        "flags": {
          "arrived": true,
          "housing_contract_active": true
        },
        "gpa_score": 61,
        "hunger": 37,
        "language": 39,
        "loneliness": 30,
        "money": 197,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 20,
        "stress": 31,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 2,
        "visa_progress": 15,
        "week": 2,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 2
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 3,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 3,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": 8,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 39,
        "language": 10,
        "loneliness": 3,
        "social": 1,
        "stress": 28,
        "visa_progress": 2
      },
      "event": {
        "id": "missing_school_registration",
        "legal_choices": [
          {
            "choice_id": "missing_school_registration.choice_02_先找_international_office",
            "failure_effects": {
              "academic_progress": -7.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "school_registered",
            "success_effects": {
              "academic_progress": -3.0,
              "stress": 4.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.87,
            "text": "先找 International Office"
          },
          {
            "choice_id": "missing_school_registration.choice_03_只靠自学顶一周",
            "failure_effects": {
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -6.0,
              "hunger": 5.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "只靠自学顶一周"
          },
          {
            "choice_id": "missing_school_registration.choice_04_继续拖延",
            "failure_effects": {
              "money": -80.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -10.0,
              "money": -80.0,
              "stress": 8.0
            },
            "success_rate": 1.0,
            "text": "继续拖延"
          }
        ],
        "selected_choice_id": "missing_school_registration.choice_03_只靠自学顶一周"
      },
      "evidence": {
        "decision_request_fingerprint": "0ba11115ee84833c97859a3916fd8421f4af8b83729a779db374c7a23b0a49c9",
        "event_request_fingerprint": "a30d088b70aa66e10f41e23d537b979c339a0f55d03aeccd0dec27b0120decb9",
        "source_line": 3,
        "source_record_sha256": "743b39d419603af612b5c96bdd121790d3c4a90aa920c473b866dc26da73eb13"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 8,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 39,
        "language": 10,
        "loneliness": 3,
        "social": 1,
        "stress": 28,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w3",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 4,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 2 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 98,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 573 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "饥饿 88。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 88,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 44,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 573,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 62,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 88,
        "language": 65,
        "loneliness": 35,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 24,
        "stress": 76,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 6,
        "visa_progress": 19,
        "week": 4,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 36,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 318,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 2,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 45,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 49,
        "language": 55,
        "loneliness": 32,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 23,
        "stress": 48,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 4,
        "visa_progress": 17,
        "week": 3,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 3
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 4,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 4,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [
        "burnout-risk"
      ],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": 10,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 10,
        "loneliness": 3,
        "social": 4,
        "stress": 24,
        "visa_progress": 8
      },
      "event": {
        "id": "wg_interview",
        "legal_choices": [
          {
            "choice_id": "wg_interview.choice_01_表现得非常德式",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "housing_stable",
            "success_effects": {
              "social": 3.0,
              "visa_progress": 6.0
            },
            "success_rate": 0.716,
            "text": "表现得非常德式"
          },
          {
            "choice_id": "wg_interview.choice_02_说自己会做中餐",
            "failure_effects": {
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "wg_cooking",
            "success_effects": {
              "hunger": -6.0,
              "loneliness": -4.0,
              "social": 7.0
            },
            "success_rate": 0.607,
            "text": "说自己会做中餐"
          },
          {
            "choice_id": "wg_interview.choice_03_坦白预算很紧",
            "failure_effects": {
              "social": -3.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "cheap_room_hint",
            "success_effects": {
              "money": 120.0,
              "stress": 5.0
            },
            "success_rate": 0.266,
            "text": "坦白预算很紧"
          },
          {
            "choice_id": "wg_interview.choice_04_过度迎合每条规则",
            "failure_effects": {
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002
            },
            "set_flag": "housing_stable",
            "success_effects": {
              "energy": -6.0,
              "social": 2.0,
              "stress": 8.0
            },
            "success_rate": 0.411,
            "text": "过度迎合每条规则"
          }
        ],
        "selected_choice_id": "wg_interview.choice_01_表现得非常德式"
      },
      "evidence": {
        "decision_request_fingerprint": "84d4f0a363fffc3103aa27dbd7393cb0b4147a479b754b4e7998a244b3b95cf3",
        "event_request_fingerprint": "7f7bfadb880164c79890b69e27c6e4f8380d3136962c2eb7cf2a52e1352d3957",
        "source_line": 4,
        "source_record_sha256": "b5130f973f712b87ca935c9ad80e4af150b530dc0648795033a7a107eb5ab031"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 10,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 10,
        "loneliness": 3,
        "social": 4,
        "stress": 24,
        "unpaid_social_streak": 2,
        "visa_progress": 8,
        "week": 1
      },
      "id": "w4",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 5,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 1 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 100,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 54,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 828,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 79,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 75,
        "loneliness": 38,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 28,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 8,
        "visa_progress": 27,
        "week": 5,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 44,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 573,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 62,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 88,
        "language": 65,
        "loneliness": 35,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 24,
        "stress": 76,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 6,
        "visa_progress": 19,
        "week": 4,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 4
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 5,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 5,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": 7,
        "career_progress": 3,
        "exam_readiness": 17,
        "language": 10,
        "loneliness": 3,
        "money": 77,
        "social": 1,
        "visa_progress": 4
      },
      "event": {
        "id": "legal_work_limit_notice",
        "legal_choices": [
          {
            "choice_id": "legal_work_limit_notice.choice_01_把工时记进日历",
            "failure_effects": {
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "stress": 2.0,
              "visa_progress": 3.0
            },
            "success_rate": 1.0,
            "text": "把工时记进日历"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_02_只接合同清楚的班",
            "failure_effects": {
              "career_progress": -1.0,
              "money": -40.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "career_progress": 3.0,
              "money": -40.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "只接合同清楚的班"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_03_问_asta/international_office",
            "failure_effects": {
              "language": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "language": 2.0,
              "stress": -1.0,
              "visa_progress": 4.0
            },
            "success_rate": 1.0,
            "text": "问 AStA/International Office"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_04_觉得自己不会超",
            "failure_effects": {
              "stress": 4.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "stress": -2.0
            },
            "success_rate": 0.316,
            "text": "觉得自己不会超"
          }
        ],
        "selected_choice_id": "legal_work_limit_notice.choice_02_只接合同清楚的班"
      },
      "evidence": {
        "decision_request_fingerprint": "2ce1ca5df46526d18f8229c1fa6b1c9e5a328eb1e9d8e6311f1df96ff899efd5",
        "event_request_fingerprint": "0425b78f3b0d80f1a26b78b79a5a128dc7d9ea0f0ff13c379b18b4a672aa3aba",
        "source_line": 5,
        "source_record_sha256": "f0bb0ba28a9b4cbfc17c3b5b33bbed4f9afed95b4040e8b016eba917213eaff0"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "blocked_account_balance": -992,
        "career_progress": 3,
        "exam_readiness": 17,
        "language": 10,
        "loneliness": 3,
        "money": 77,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 4,
        "week": 1
      },
      "id": "w5",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 6,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 0 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 100,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 61,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 828,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 85,
        "loneliness": 41,
        "money": 77,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 29,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 10,
        "visa_progress": 31,
        "week": 6,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 54,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 828,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 79,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 75,
        "loneliness": 38,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 28,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 8,
        "visa_progress": 27,
        "week": 5,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 5
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 6,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 6,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [
        "cashflow-stress-attractor"
      ],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": 7,
        "exam_readiness": 4,
        "language": 10,
        "loneliness": 3,
        "money": -77,
        "social": 1,
        "stress": -5,
        "visa_progress": -6
      },
      "event": {
        "id": "anmeldung_deadline",
        "legal_choices": [
          {
            "choice_id": "anmeldung_deadline.choice_01_立刻补材料",
            "failure_effects": {
              "energy": -4.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": -4.0,
              "stress": 4.0,
              "visa_progress": 7.0
            },
            "success_rate": 1.0,
            "text": "立刻补材料"
          },
          {
            "choice_id": "anmeldung_deadline.choice_02_先问_international_office",
            "failure_effects": {
              "language": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "language": 1.0,
              "stress": -2.0,
              "visa_progress": 5.0
            },
            "success_rate": 1.0,
            "text": "先问 International Office"
          },
          {
            "choice_id": "anmeldung_deadline.choice_03_请室友确认_wohnungsgeberbestätigung",
            "failure_effects": {
              "stress": 6.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002,
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "social": 3.0,
              "stress": 1.0,
              "visa_progress": 6.0
            },
            "success_rate": 0.851,
            "text": "请室友确认 Wohnungsgeberbestätigung"
          },
          {
            "choice_id": "anmeldung_deadline.choice_04_把信封塞进抽屉",
            "failure_effects": {
              "money": -30.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "admin_avoidance",
            "success_effects": {
              "money": -30.0,
              "stress": -5.0,
              "visa_progress": -8.0
            },
            "success_rate": 1.0,
            "text": "把信封塞进抽屉"
          }
        ],
        "selected_choice_id": "anmeldung_deadline.choice_04_把信封塞进抽屉"
      },
      "evidence": {
        "decision_request_fingerprint": "05732f700973ff50a01d2ed6c7da0807c8b6eccd56da7d24802496fa78f3ae2a",
        "event_request_fingerprint": "29a54d4ceb61c94ba6379d33b73e8fd82e78cca20262b1a4a4cc9bd2db5082cd",
        "source_line": 6,
        "source_record_sha256": "aa39777c9c1a623ede01420f0d1831e47f34550db018bc0bc15de7ae6da43faf"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 208,
        "cash_shortfall_count": 2,
        "exam_readiness": 4,
        "language": 10,
        "loneliness": 3,
        "money": -77,
        "social": 1,
        "stress": -5,
        "unpaid_social_streak": 2,
        "visa_progress": -6,
        "week": 1
      },
      "id": "w6",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 7,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 1036 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "压力 95。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 95,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 68,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1036,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 6,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 95,
        "loneliness": 44,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 30,
        "stress": 95,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 12,
        "visa_progress": 25,
        "week": 7,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 61,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 828,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 85,
        "loneliness": 41,
        "money": 77,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 29,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 10,
        "visa_progress": 31,
        "week": 6,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 6
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 7,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 7,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": -2,
        "language": 5,
        "loneliness": 3,
        "social": 1,
        "stress": 5,
        "visa_progress": 2
      },
      "event": {
        "id": "registration_window_missed",
        "legal_choices": [
          {
            "choice_id": "registration_window_missed.choice_01_接受下学期再注册",
            "failure_effects": {
              "money": -650.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -12.0,
              "money": -650.0,
              "stress": 14.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "接受下学期再注册"
          },
          {
            "choice_id": "registration_window_missed.choice_03_转入语言班等待下学期",
            "failure_effects": {
              "language": -1.0,
              "money": -900.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -9.0,
              "language": 8.0,
              "money": -900.0,
              "stress": 10.0
            },
            "success_rate": 1.0,
            "text": "转入语言班等待下学期"
          },
          {
            "choice_id": "registration_window_missed.choice_04_逃避邮件和截止日",
            "failure_effects": {
              "money": -420.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -16.0,
              "hunger": 8.0,
              "money": -420.0,
              "stress": 22.0
            },
            "success_rate": 1.0,
            "text": "逃避邮件和截止日"
          }
        ],
        "selected_choice_id": "registration_window_missed.choice_03_转入语言班等待下学期"
      },
      "evidence": {
        "decision_request_fingerprint": "2ed13d0940726cc722281bec136ea005991fd1e742856718d6e7d2a25a06a0b9",
        "event_request_fingerprint": "fcbacde30efcda9ec4fafde99972c5f9ca2615f8175a9cfe0dc36f4694f749b1",
        "source_line": 7,
        "source_record_sha256": "c6d7b822be54a963c91dd2eadb38256e39d92e586d16944f96e62ef5ce7fc4e4"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -2,
        "arrears_amount": 1155,
        "cash_shortfall_count": 2,
        "language": 5,
        "loneliness": 3,
        "social": 1,
        "stress": 5,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w7",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 8,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2191 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 66,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2191,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 8,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 47,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 31,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 14,
        "visa_progress": 27,
        "week": 8,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 68,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1036,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 6,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 95,
        "loneliness": 44,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 30,
        "stress": 95,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 12,
        "visa_progress": 25,
        "week": 7,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 7
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 8,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 8,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "parents_money_hint",
              "max_weeks": 8,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 8
            },
            "streak_weeks": 6,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 6 consecutive weeks (week=8).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 8
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": 7,
        "loneliness": 3,
        "money": 35,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "parents_money_hint",
        "legal_choices": [
          {
            "choice_id": "parents_money_hint.choice_01_做预算表给他们看",
            "failure_effects": {
              "money": -35.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 120.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "做预算表给他们看"
          },
          {
            "choice_id": "parents_money_hint.choice_02_先安慰他们",
            "failure_effects": {
              "loneliness": 2.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "loneliness": -3.0,
              "stress": 2.0
            },
            "success_rate": 1.0,
            "text": "先安慰他们"
          },
          {
            "choice_id": "parents_money_hint.choice_03_稳妥处理",
            "failure_effects": {
              "money": 35.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 105.0,
              "stress": 1.0
            },
            "success_rate": 0.412,
            "text": "稳妥处理"
          },
          {
            "choice_id": "parents_money_hint.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 70.0,
              "social": 2.0,
              "stress": -2.0
            },
            "success_rate": 0.63,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "parents_money_hint.choice_03_稳妥处理"
      },
      "evidence": {
        "decision_request_fingerprint": "e1bb235e738417b4d6581a2d4749ded0a09cf20ab1de71d8dd6d4ceac96e696e",
        "event_request_fingerprint": "1b4c995afda2e1869e323aaaae4ed535c405c2ac85c4edf8be5d3464e1f84f97",
        "source_line": 8,
        "source_record_sha256": "3d06a263612da0a16c9fa3d697866c887580e2d8a46f2c1b6a84b1d82ce1d369"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "money": 35,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w8",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 9,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 35 EUR，逾期 2446 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 73,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2446,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 9,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 50,
        "money": 35,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 32,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 16,
        "visa_progress": 29,
        "week": 9,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 66,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2191,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 8,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 47,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 31,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 14,
        "visa_progress": 27,
        "week": 8,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 8
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exam_registration",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 9
            },
            "streak_weeks": 7,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 7 consecutive weeks (week=9).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 9
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "bank_account",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": 7,
        "exam_readiness": -4,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "exam_registration",
        "legal_choices": [
          {
            "choice_id": "exam_registration.choice_01_马上报名",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "exam_registered",
            "success_effects": {
              "academic_progress": 2.0,
              "exam_readiness": 4.0,
              "stress": -3.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "马上报名"
          },
          {
            "choice_id": "exam_registration.choice_02_报名后顺手查考纲",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "exam_registered",
            "success_effects": {
              "academic_progress": 1.0,
              "exam_readiness": 7.0,
              "stress": 1.0
            },
            "success_rate": 1.0,
            "text": "报名后顺手查考纲"
          },
          {
            "choice_id": "exam_registration.choice_03_先问同学报名流程",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "exam_registered",
            "success_effects": {
              "exam_readiness": 3.0,
              "social": 3.0,
              "stress": 1.0
            },
            "success_rate": 0.635,
            "text": "先问同学报名流程"
          },
          {
            "choice_id": "exam_registration.choice_04_晚点再说",
            "failure_effects": {
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "exam_readiness": -4.0,
              "stress": 5.0
            },
            "success_rate": 1.0,
            "text": "晚点再说"
          }
        ],
        "selected_choice_id": "exam_registration.choice_04_晚点再说"
      },
      "evidence": {
        "decision_request_fingerprint": "42fe328beb46769d692d2efe6a4a9e21204559bb39977cadb9252a97815f4c4f",
        "event_request_fingerprint": "fd4292c01238413f4393b1ca0925a9192e29429e1d7b77f3e0f3f68b47592b46",
        "source_line": 9,
        "source_record_sha256": "7434ede8da8604ba81c3259805e5ab0383c009b29447d69ca27097012b88402f"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "blocked_account_balance": -992,
        "exam_readiness": -4,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w9",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 10,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 152 EUR，逾期 2446 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 80,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2446,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 9,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 53,
        "money": 152,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 33,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 18,
        "visa_progress": 31,
        "week": 10,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 73,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2446,
        "blocked_account_balance": 9920,
        "career_progress": 3,
        "cash_shortfall_count": 9,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 50,
        "money": 35,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 32,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 16,
        "visa_progress": 29,
        "week": 9,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 9
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "midterm_pressure",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 10
            },
            "streak_weeks": 8,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 8 consecutive weeks (week=10).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 10
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "therapy",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": 14,
        "exam_readiness": 4,
        "loneliness": 3,
        "money": -152,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "midterm_pressure",
        "legal_choices": [
          {
            "choice_id": "midterm_pressure.choice_01_整理学习计划",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 5.0,
              "exam_readiness": 4.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "整理学习计划"
          },
          {
            "choice_id": "midterm_pressure.choice_02_先睡一觉",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -2.0,
              "energy": 16.0,
              "exam_readiness": -2.0,
              "stress": -6.0
            },
            "success_rate": 1.0,
            "text": "先睡一觉"
          },
          {
            "choice_id": "midterm_pressure.choice_03_砍掉一班打工补作业",
            "failure_effects": {
              "academic_progress": -1.0,
              "money": -139.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 7.0,
              "exam_readiness": 5.0,
              "money": -139.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "砍掉一班打工补作业"
          },
          {
            "choice_id": "midterm_pressure.choice_04_靠咖啡硬顶",
            "failure_effects": {
              "academic_progress": -1.0,
              "energy": -12.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 4.0,
              "energy": -12.0,
              "exam_readiness": 2.0,
              "stress": 10.0
            },
            "success_rate": 1.0,
            "text": "靠咖啡硬顶"
          }
        ],
        "selected_choice_id": "midterm_pressure.choice_03_砍掉一班打工补作业"
      },
      "evidence": {
        "decision_request_fingerprint": "3ea29ab7cfedd2e3f36bbf10c24978d84d97ee30d3fb4f79c344d60e82cf6757",
        "event_request_fingerprint": "1cbd50f185cdf35249c6b218165337e5076e455c9213c658c658c6f78d32d135",
        "source_line": 10,
        "source_record_sha256": "063f751a887718ad28ae02b026d1d7a0f1d75937ac8ae39f7952ab70cb024f9d"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 14,
        "arrears_amount": 242,
        "cash_shortfall_count": 2,
        "exam_readiness": 4,
        "loneliness": 3,
        "money": -152,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w10",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 11,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2688 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 94,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2688,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 56,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 34,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 20,
        "visa_progress": 33,
        "week": 11,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 80,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2446,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 9,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 53,
        "money": 152,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 33,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 18,
        "visa_progress": 31,
        "week": 10,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 10
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wechat_silence",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 11
            },
            "streak_weeks": 9,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 9 consecutive weeks (week=11).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 11
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": -1,
        "loneliness": 3,
        "visa_progress": 2
      },
      "event": {
        "id": "wechat_silence",
        "legal_choices": [
          {
            "choice_id": "wechat_silence.choice_01_写一段真实记录",
            "failure_effects": {
              "loneliness": 2.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "loneliness": -5.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "写一段真实记录"
          },
          {
            "choice_id": "wechat_silence.choice_02_继续潜水",
            "failure_effects": {
              "energy": -4.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 2.0,
              "loneliness": 3.0
            },
            "success_rate": 1.0,
            "text": "继续潜水"
          },
          {
            "choice_id": "wechat_silence.choice_03_稳妥处理",
            "failure_effects": {
              "energy": 0.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "stress": -2.0
            },
            "success_rate": 0.196,
            "text": "稳妥处理"
          },
          {
            "choice_id": "wechat_silence.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "social": 2.0,
              "stress": -4.0
            },
            "success_rate": 0.411,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "wechat_silence.choice_04_寻求帮助"
      },
      "evidence": {
        "decision_request_fingerprint": "eb575ea9c1cbd998310d565fbd543b8751f8640df16487fff9563d426daae0e7",
        "event_request_fingerprint": "ea0f03af01e82006af91bb3311ee5a5b5c4ed9fb4c0a7fbcba5d0d32c0ce853d",
        "source_line": 11,
        "source_record_sha256": "0459ff066a2bf3a3442a8759d54f75661bb4f7bb9ad13f852516e7d12d20ba9c"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -1,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w11",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 12,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2943 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2943,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 59,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 34,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 22,
        "visa_progress": 35,
        "week": 12,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 94,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2688,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 56,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 34,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 20,
        "visa_progress": 33,
        "week": 11,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 11
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "group_invite",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 12
            },
            "streak_weeks": 10,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 10 consecutive weeks (week=12).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 12
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": 4,
        "loneliness": 3,
        "social": 4,
        "visa_progress": 2
      },
      "event": {
        "id": "group_invite",
        "legal_choices": [
          {
            "choice_id": "group_invite.choice_01_答应并主动分工",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002,
              "social": 0.003
            },
            "set_flag": "anna_group",
            "success_effects": {
              "academic_progress": 6.0,
              "exam_readiness": 4.0,
              "language": 3.0,
              "social": 8.0
            },
            "success_rate": 0.9,
            "text": "答应并主动分工"
          },
          {
            "choice_id": "group_invite.choice_02_只接资料整理的部分",
            "failure_effects": {
              "academic_progress": -1.0,
              "social": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "anna_group",
            "success_effects": {
              "academic_progress": 4.0,
              "exam_readiness": 2.0,
              "social": 3.0,
              "stress": 2.0
            },
            "success_rate": 1.0,
            "text": "只接资料整理的部分"
          },
          {
            "choice_id": "group_invite.choice_03_请她先解释评分标准",
            "failure_effects": {
              "stress": 6.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003,
              "social": 0.002
            },
            "set_flag": "anna_group",
            "success_effects": {
              "exam_readiness": 6.0,
              "language": 3.0,
              "social": 5.0
            },
            "success_rate": 0.841,
            "text": "请她先解释评分标准"
          },
          {
            "choice_id": "group_invite.choice_04_委婉拒绝",
            "failure_effects": {
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "social": -4.0,
              "stress": -3.0
            },
            "success_rate": 1.0,
            "text": "委婉拒绝"
          }
        ],
        "selected_choice_id": "group_invite.choice_02_只接资料整理的部分"
      },
      "evidence": {
        "decision_request_fingerprint": "95acacdf87f2bd5ffa867e3d0ddf9747765689b51a6ee8264d5d800aa3e4e5ac",
        "event_request_fingerprint": "da9844cab7a87fdf9666d31962cd54d6bf3724e166af1c8f01eb91689f75cb6f",
        "source_line": 12,
        "source_record_sha256": "1399d7ed3ab1ebdcc1cfa3b88fe4ec657cb87b3ff447d62ec92a34478935a361"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 4,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "social": 4,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w12",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 13,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3198 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 97,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3198,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 13,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 62,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 38,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 24,
        "visa_progress": 37,
        "week": 13,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2943,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 59,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 34,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 22,
        "visa_progress": 35,
        "week": 12,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 12
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exercise_sheet_warning",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 13
            },
            "streak_weeks": 11,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 11 consecutive weeks (week=13).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 13
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": -4,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "exercise_sheet_warning",
        "legal_choices": [
          {
            "choice_id": "exercise_sheet_warning.choice_01_补三套练习题",
            "failure_effects": {
              "exam_readiness": 2.0,
              "stress": 10.0
            },
            "next_event_id": "",
            "requirements": {
              "academic_progress": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "exam_readiness": 10.0,
              "stress": 6.0
            },
            "success_rate": 0.775,
            "text": "补三套练习题"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_02_去_tutorium_问清楚",
            "failure_effects": {
              "stress": 7.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 7.0,
              "language": 2.0,
              "stress": 3.0
            },
            "success_rate": 0.756,
            "text": "去 Tutorium 问清楚"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_03_和同学对答案",
            "failure_effects": {
              "exam_readiness": -2.0,
              "stress": 6.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 6.0,
              "social": 4.0,
              "stress": 2.0
            },
            "success_rate": 0.513,
            "text": "和同学对答案"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_04_先忙别的",
            "failure_effects": {
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "exam_readiness": -8.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "先忙别的"
          }
        ],
        "selected_choice_id": "exercise_sheet_warning.choice_02_去_tutorium_问清楚"
      },
      "evidence": {
        "decision_request_fingerprint": "d6302cd8432e0144c56e1d707517a0f21d289967eaf5cc9d1a09d9082d31132c",
        "event_request_fingerprint": "1587719356c371f1f3f5f2934d418f2830791fc9605106291a1fb71856853218",
        "source_line": 13,
        "source_record_sha256": "34970c347c948f3efcb5a8246ff1e79d4c5acb07e3c21e2d21510777e122c0e7"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -4,
        "blocked_account_balance": -992,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w13",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 14,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 117 EUR，逾期 3198 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3198,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 13,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 65,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 39,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 26,
        "visa_progress": 39,
        "week": 14,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 97,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3198,
        "blocked_account_balance": 8928,
        "career_progress": 3,
        "cash_shortfall_count": 13,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 62,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 38,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 24,
        "visa_progress": 37,
        "week": 13,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 13
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 12,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 12 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "visa_progress": 9
      },
      "event": {
        "id": "visa_status_hidden_check",
        "legal_choices": [
          {
            "choice_id": "visa_status_hidden_check.choice_01_立刻联系外管局和学校",
            "failure_effects": {
              "stress": 14.0,
              "visa_progress": -3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "visa_valid",
            "success_effects": {
              "language": 2.0,
              "stress": 9.0,
              "visa_progress": 9.0
            },
            "success_rate": 0.756,
            "text": "立刻联系外管局和学校"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_02_补材料并申请_fiktionsbescheinigung",
            "failure_effects": {
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "visa_valid",
            "success_effects": {
              "stress": 7.0,
              "visa_progress": 7.0
            },
            "success_rate": 0.676,
            "text": "补材料并申请 Fiktionsbescheinigung"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_03_只在网页上继续刷_termin",
            "failure_effects": {
              "stress": 16.0,
              "visa_progress": -4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "deportation_warning",
            "success_effects": {
              "stress": 10.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.436,
            "text": "只在网页上继续刷 Termin"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_04_相信不会查到自己",
            "failure_effects": {
              "stress": 8.0,
              "visa_progress": -12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "deportation_warning",
            "success_effects": {
              "stress": -2.0,
              "visa_progress": -8.0
            },
            "success_rate": 0.366,
            "text": "相信不会查到自己"
          }
        ],
        "selected_choice_id": "visa_status_hidden_check.choice_02_补材料并申请_fiktionsbescheinigung"
      },
      "evidence": {
        "decision_request_fingerprint": "157c1759b8545cb41f856a8a79ab2ee152e35f3d70226a41d25b249d35d620ec",
        "event_request_fingerprint": "69ed094d9bb88a057de4028727de42e226ac956b8e5ef26d709faf203308c7d4",
        "source_line": 14,
        "source_record_sha256": "890f5f1e13b4a6519cc3855b16590a963f29af02a781b0ba36071c0b0f1ba217"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 138,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 9,
        "week": 1
      },
      "id": "w14",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 15,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3336 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3336,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 68,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 40,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 28,
        "visa_progress": 48,
        "week": 15,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3198,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 13,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 65,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 39,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 26,
        "visa_progress": 39,
        "week": 14,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 14
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": -34.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "desperate_illegal_work_offer",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 15
            },
            "to": 66.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 66 in a single week (Δ=-34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 15
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 0,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 0 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "hunger": -34,
        "loneliness": 3,
        "money": 20,
        "visa_progress": 2
      },
      "event": {
        "id": "desperate_illegal_work_offer",
        "legal_choices": [
          {
            "choice_id": "desperate_illegal_work_offer.choice_01_找学生会紧急援助",
            "failure_effects": {
              "hunger": -8.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -18.0,
              "money": 120.0,
              "social": 2.0,
              "stress": 6.0
            },
            "success_rate": 0.475,
            "text": "找学生会紧急援助"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_03_向同学或父母借钱",
            "failure_effects": {
              "loneliness": 5.0,
              "stress": 16.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -12.0,
              "loneliness": -3.0,
              "money": 260.0,
              "stress": 9.0
            },
            "success_rate": 0.458,
            "text": "向同学或父母借钱"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_04_接下现金黑工",
            "failure_effects": {
              "energy": -25.0,
              "illegal_work_hours": 14.0,
              "stress": 24.0,
              "visa_progress": -8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "illegal_work_taken",
            "success_effects": {
              "academic_progress": -9.0,
              "energy": -34.0,
              "hunger": -18.0,
              "illegal_work_hours": 36.0,
              "stress": 20.0
            },
            "success_rate": 0.591,
            "text": "接下现金黑工"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_05_去食物救助/低价食堂",
            "failure_effects": {
              "hunger": -18.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -34.0,
              "money": 20.0,
              "social": -1.0,
              "stress": 8.0
            },
            "success_rate": 0.635,
            "text": "去食物救助/低价食堂"
          }
        ],
        "selected_choice_id": "desperate_illegal_work_offer.choice_05_去食物救助/低价食堂"
      },
      "evidence": {
        "decision_request_fingerprint": "414f68ce93f1e066b99a13b193fcc6372d2862734b63b1c3fd42b1df406be02c",
        "event_request_fingerprint": "d88764f7dbc31dc6394938bd85f022de3af81150ba8b749085dbf994bda5f05c",
        "source_line": 15,
        "source_record_sha256": "c3c5f3e7a5933992515a27b33e5b9517cee429824dbf3445a8ce54f30e954a41"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "hunger": -34,
        "loneliness": 3,
        "money": 20,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w15",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 16,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "当前可支配现金 20 EUR，逾期 3591 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "正常注册窗口已错过，只能准备下学期注册并控制生活成本。",
            "id": "registration_delayed",
            "score": 82,
            "suggested_actions": [
              "next_semester_registration",
              "international_office"
            ],
            "title": "注册已延期"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3591,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 66,
        "language": 100,
        "loneliness": 71,
        "money": 20,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 40,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 30,
        "visa_progress": 50,
        "week": 16,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3336,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 68,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 40,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 28,
        "visa_progress": 48,
        "week": 15,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 15
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": -34.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "desperate_illegal_work_offer",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 15
            },
            "to": 66.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 66 in a single week (Δ=-34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 15
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 66.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "klausur_countdown",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 16
            },
            "to": 100.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 66.0 to 100 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 16
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 1,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 1 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": 5,
        "energy": 8,
        "hunger": 34,
        "loneliness": 3,
        "money": -20,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "klausur_countdown",
        "legal_choices": [
          {
            "choice_id": "klausur_countdown.choice_01_整理错题清单",
            "failure_effects": {
              "exam_readiness": 2.0,
              "stress": 9.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.004
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 12.0,
              "stress": 5.0
            },
            "success_rate": 0.474,
            "text": "整理错题清单"
          },
          {
            "choice_id": "klausur_countdown.choice_02_约教授/助教答疑",
            "failure_effects": {
              "stress": 9.0
            },
            "next_event_id": "",
            "requirements": {
              "academic_progress": 0.003,
              "language": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "exam_readiness": 8.0,
              "stress": 3.0
            },
            "success_rate": 0.678,
            "text": "约教授/助教答疑"
          },
          {
            "choice_id": "klausur_countdown.choice_03_和小组模拟考试",
            "failure_effects": {
              "exam_readiness": 1.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 9.0,
              "social": 4.0,
              "stress": 4.0
            },
            "success_rate": 0.547,
            "text": "和小组模拟考试"
          },
          {
            "choice_id": "klausur_countdown.choice_04_继续拖延",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 5.0,
              "exam_readiness": -12.0,
              "stress": -4.0
            },
            "success_rate": 1.0,
            "text": "继续拖延"
          }
        ],
        "selected_choice_id": "klausur_countdown.choice_02_约教授/助教答疑"
      },
      "evidence": {
        "decision_request_fingerprint": "6639234e734c9a150cab13fdd1e77e8b151e9d5d92784112ce74ce723a4a7645",
        "event_request_fingerprint": "626446f59bbe1282cf6dae4d537ec5559daad3f2e242551ee30bd928a4769e58",
        "source_line": 16,
        "source_record_sha256": "cc8665272b74578759e9b52cc34ddc560709ee3dd0216c473ca5364a39e32e3e"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 5,
        "arrears_amount": 235,
        "cash_shortfall_count": 1,
        "energy": 8,
        "hunger": 34,
        "loneliness": 3,
        "money": -20,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w16",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 17,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3826 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 98,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3826,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 16,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 74,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 41,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 32,
        "visa_progress": 52,
        "week": 17,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3591,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 66,
        "language": 100,
        "loneliness": 71,
        "money": 20,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 40,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 30,
        "visa_progress": 50,
        "week": 16,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 16
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": -34.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "desperate_illegal_work_offer",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 15
            },
            "to": 66.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 66 in a single week (Δ=-34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 15
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 66.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "klausur_countdown",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 16
            },
            "to": 100.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 66.0 to 100 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 16
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 2,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 2 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": -5,
        "energy": -8,
        "loneliness": 3,
        "money": 117,
        "visa_progress": 2
      },
      "event": {
        "id": "family_compare",
        "legal_choices": [
          {
            "choice_id": "family_compare.choice_01_少看消息",
            "failure_effects": {
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "loneliness": 2.0,
              "stress": -6.0
            },
            "success_rate": 1.0,
            "text": "少看消息"
          },
          {
            "choice_id": "family_compare.choice_02_认真解释自己的节奏",
            "failure_effects": {
              "career_progress": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "career_progress": 2.0,
              "stress": 4.0
            },
            "success_rate": 1.0,
            "text": "认真解释自己的节奏"
          },
          {
            "choice_id": "family_compare.choice_03_稳妥处理",
            "failure_effects": {
              "energy": 0.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "stress": -2.0
            },
            "success_rate": 0.196,
            "text": "稳妥处理"
          },
          {
            "choice_id": "family_compare.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "social": 2.0,
              "stress": -4.0
            },
            "success_rate": 0.407,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "family_compare.choice_04_寻求帮助"
      },
      "evidence": {
        "decision_request_fingerprint": "edacf14a089ca217df3f19a238f888cd6a09d3041ec4102dae0d4f690c791ebc",
        "event_request_fingerprint": "890c53596ee2b4d2198ca529dd08c41efddc4c4409eea3f7d213458c5c191a0c",
        "source_line": 17,
        "source_record_sha256": "1030de6f2a11d901fb075cfdc99ff4fadaf9f46bf3363480130f302250658907"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -5,
        "blocked_account_balance": -992,
        "energy": -8,
        "loneliness": 3,
        "money": 117,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w17",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 18,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 117 EUR，逾期 3826 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3826,
        "blocked_account_balance": 6944,
        "career_progress": 3,
        "cash_shortfall_count": 16,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 77,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 41,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 34,
        "visa_progress": 54,
        "week": 18,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 98,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3826,
        "blocked_account_balance": 7936,
        "career_progress": 3,
        "cash_shortfall_count": 16,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 74,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 41,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 32,
        "visa_progress": 52,
        "week": 17,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 17
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": -34.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "desperate_illegal_work_offer",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 15
            },
            "to": 66.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 66 in a single week (Δ=-34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 15
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 66.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "klausur_countdown",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 16
            },
            "to": 100.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 66.0 to 100 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 16
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 3,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 3 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "energy": -4,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "exam_week",
        "legal_choices": [
          {
            "choice_id": "exam_week.choice_01_先做会的题",
            "failure_effects": {
              "exam_readiness": -3.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.004,
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 5.0,
              "stress": 4.0
            },
            "success_rate": 0.432,
            "text": "先做会的题"
          },
          {
            "choice_id": "exam_week.choice_02_硬翻译题目",
            "failure_effects": {
              "exam_readiness": -4.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.004,
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 2.0,
              "language": 3.0,
              "stress": 7.0
            },
            "success_rate": 0.592,
            "text": "硬翻译题目"
          },
          {
            "choice_id": "exam_week.choice_03_先扫整张卷子分配时间",
            "failure_effects": {
              "stress": 7.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.005
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 7.0,
              "stress": 2.0
            },
            "success_rate": 0.392,
            "text": "先扫整张卷子分配时间"
          },
          {
            "choice_id": "exam_week.choice_04_盯着第一题死磕",
            "failure_effects": {
              "exam_readiness": -8.0,
              "stress": 14.0
            },
            "next_event_id": "",
            "requirements": {
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": -5.0,
              "stress": 10.0
            },
            "success_rate": 0.092,
            "text": "盯着第一题死磕"
          }
        ],
        "selected_choice_id": "exam_week.choice_03_先扫整张卷子分配时间"
      },
      "evidence": {
        "decision_request_fingerprint": "68b4e3ad649c09effe8d843649cae60186d9b021438e70b3bb33abfc1e784336",
        "event_request_fingerprint": "5d0d73b7b7a080386f9f91ffec9884708b561f9c6ca553c238db444824fb6f4f",
        "source_line": 18,
        "source_record_sha256": "fe4f9d6ed9da4efd626145831270b63748cf78419dcfe874ff680ddac4cc19c2"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 138,
        "cash_shortfall_count": 1,
        "energy": -4,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w18",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 19,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3964 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3964,
        "blocked_account_balance": 6944,
        "career_progress": 3,
        "cash_shortfall_count": 17,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 80,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 42,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 36,
        "visa_progress": 56,
        "week": 19,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3826,
        "blocked_account_balance": 6944,
        "career_progress": 3,
        "cash_shortfall_count": 16,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 77,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 41,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 34,
        "visa_progress": 54,
        "week": 18,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 18
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": -32.0,
            "from": 64.0,
            "metric": "energy",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "germany_language_track_start",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 2
            },
            "to": 32.0
          },
          "kind": "single_week_spike",
          "message": "`energy` jumped from 64.0 to 32 in a single week (Δ=-32.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 2
        },
        {
          "evidence": {
            "delta": 39.0,
            "from": 49.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 88.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 49.0 to 88 in a single week (Δ=+39.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": -34.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "desperate_illegal_work_offer",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 15
            },
            "to": 66.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 66 in a single week (Δ=-34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 15
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 66.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "klausur_countdown",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 16
            },
            "to": 100.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 66.0 to 100 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 16
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "language_tandem",
                "problem_set",
                "library_day",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 4,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 4 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise slacker priorities"
      },
      "delta": {
        "academic_progress": 3,
        "loneliness": 3,
        "social": 1,
        "stress": -4,
        "visa_progress": 2
      },
      "event": {
        "id": "after_exam_void",
        "legal_choices": [
          {
            "choice_id": "after_exam_void.choice_01_休息半天",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 12.0,
              "stress": -10.0
            },
            "success_rate": 1.0,
            "text": "休息半天"
          },
          {
            "choice_id": "after_exam_void.choice_02_立刻复盘",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "立刻复盘"
          },
          {
            "choice_id": "after_exam_void.choice_03_稳妥处理",
            "failure_effects": {
              "academic_progress": 1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "stress": 1.0
            },
            "success_rate": 0.578,
            "text": "稳妥处理"
          },
          {
            "choice_id": "after_exam_void.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 2.0,
              "social": 2.0,
              "stress": -2.0
            },
            "success_rate": 0.789,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "after_exam_void.choice_03_稳妥处理"
      },
      "evidence": {
        "decision_request_fingerprint": "813f390110b310bf50a626c8f9e0b8a8e545cfbd4c7d8240315ae92e0145a9e8",
        "event_request_fingerprint": "c080379786ee10fe63f83c50faf185042ab97e252aa87e74c8684d61ae9ea3e8",
        "source_line": 19,
        "source_record_sha256": "071be50c20cddb082ce500382df666dc7bb2dfaa1af3d49507bbe480fdafa59a"
      },
      "finished": true,
      "full_numeric_delta": {
        "academic_progress": 3,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "social": 1,
        "stress": -4,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w19",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 20,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 4219 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "压力 96。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 96,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          }
        ]
      },
      "selected_action_ids": [
        "language_tandem",
        "problem_set",
        "library_day",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 96,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 4219,
        "blocked_account_balance": 6944,
        "career_progress": 3,
        "cash_shortfall_count": 18,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 83,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 43,
        "stress": 96,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 38,
        "visa_progress": 58,
        "week": 20,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3964,
        "blocked_account_balance": 6944,
        "career_progress": 3,
        "cash_shortfall_count": 17,
        "current_week_work_hours": 0,
        "energy": 12,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "anna_group": true,
          "arrears": true,
          "arrived": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 80,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 42,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 36,
        "visa_progress": 56,
        "week": 19,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 19
    }
  ],
  "persona": "slacker",
  "provider": "replay",
  "provider_mode": "replay",
  "provider_revision": "fixture:865f4fb83028f7ada18b581462adef3cbb15f2b06ed4c59cb0601f97b0d5f590",
  "scenario": "default_first_semester",
  "schema_version": "playthrough-view-v1",
  "seed": 42,
  "source_trace": {
    "artifact_path": "reports/playthrough-evidence/campaigns/playthrough-evidence-full-v1/cells/slacker-seed-42-40927837a583/playthrough.jsonl",
    "artifact_sha256": "259b392def04014af601714772980148590fb25e8f94abde1f36b4c307516823",
    "record_count": 19
  },
  "stop_reason": "game_finished",
  "truth_label": "prerecorded-real-godot-replay"
}
